import { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { ArrowRight } from 'lucide-react';

export default function RoofingMetal() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />

      {/* HERO */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="relative h-[600px] mb-0 overflow-hidden"
      >
        <img
          src="https://media.base44.com/images/public/69db395aa041ab4d87ab84d7/2caf4cdef_Metalroof.jpg"
          alt="Stående fals i metall"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-black/20"></div>
        <div className="absolute inset-0 flex flex-col justify-end p-12 z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <p className="text-sm tracking-widest-2xl font-body uppercase text-white/60 mb-6">Artikkel 1</p>
            <h1 className="font-heading text-6xl md:text-7xl lg:text-8xl font-light leading-[1.0] text-white mb-6">
              Stående fals i metall
            </h1>
            <p className="font-body text-white/80 text-xl max-w-2xl leading-relaxed">
              Presist, rolig og tydelig, et klassisk og minimalistisk takvalg
            </p>
          </motion.div>
        </div>
      </motion.div>

      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <motion.section
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="py-20"
        >
          <div className="max-w-4xl">
            <h2 className="font-heading text-5xl font-light leading-[1.1] mb-8 text-[#2a1810]">
              Presist design møter nordisk enkelthet
            </h2>
            <p className="font-body text-2xl text-foreground/70 leading-relaxed mb-6">
              Stående fals i metall er valget for deg som ønsker et rent, geometrisk uttrykk. Taket gir badstuen en tydelig silhuett og fungerer godt både i moderne og naturlige omgivelser.
            </p>
            <p className="font-body text-2xl text-foreground/70 leading-relaxed mb-12">
              Vi tilbyr tre rolige fargealternativer som passer godt mot både mørk skog, berg og urbane kontekster.
            </p>

            <div className="grid md:grid-cols-3 gap-6 mb-16">
              {[
                { color: 'Svart matt', desc: 'Klassisk og elegant, fungerer som bakgrunn for omgivelsene' },
                { color: 'Lys grå', desc: 'Subtil og tilpasningsdyktig, fungerer i de fleste settinger' },
                { color: 'Grafitt', desc: 'Rolig mørkegrå, gir dybde uten å dominere' }
              ].map((item, idx) => (
                <motion.div
                  key={idx}
                  whileHover={{ y: -4 }}
                  className="bg-white border border-border/20 rounded-[8px] p-8 hover:border-[#2d5a3d] hover:shadow-md transition-all"
                >
                  <h3 className="font-heading text-2xl font-light text-[#2a1810] mb-3">{item.color}</h3>
                  <p className="font-body text-2xl text-foreground/70">{item.desc}</p>
                </motion.div>
              ))}
            </div>

            <div className="bg-gradient-to-br from-[#2a1810] to-[#3d2818] text-white rounded-[8px] p-12 mb-12">
              <h3 className="font-heading text-2xl font-light mb-6">Fordeler med stål fals</h3>
              <ul className="space-y-4 font-body text-white/80 text-2xl">
                <li className="flex gap-3">
                  <span className="text-primary font-light text-2xl">✓</span>
                  <span>Minimal vedlikehold — ingen farging eller behandling nødvendig</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-primary font-light text-2xl">✓</span>
                  <span>Langvarig — stål holder i mange tiår uten slitasje</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-primary font-light text-2xl">✓</span>
                  <span>Tydelig geometri — gir badstuen en klar silhuett</span>
                </li>
                <li className="flex gap-3">
                  <span className="text-primary font-light text-2xl">✓</span>
                  <span>Fleksibelt — fungerer både moderne og klassisk</span>
                </li>
              </ul>
            </div>

            <motion.a
              whileHover={{ scale: 1.02 }}
              href="/laer-mer-handverk"
              className="inline-flex items-center gap-2 px-8 py-4 bg-[#2a1810] text-white font-body tracking-widest text-2xl font-semibold rounded-[4px] hover:bg-[#2a1810]/90 transition-all"
            >
              Tilbake til Lær Mer <ArrowRight size={16} />
            </motion.a>
          </div>
        </motion.section>
      </div>

      <Footer />
    </div>
  );
}